export default __webpack_public_path__ + "static/media/locked.7174ac15.svg";